<template>
  <div class="page-wrapper">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <div class="page-breadcrumb">
      <div class="row">
        <div class="col-md-5 align-self-center">
          <h4 class="page-title">{{ $t("audit") }}</h4>
        </div>
        <div class="col-md-7 align-self-center">
          <div class="d-flex align-items-center justify-content-end">
            <a
              class="btn btn-secondary"
              download="logs.csv"
              @click.prevent="exportRecord"
              href="javascript:void(0)"
            >
              {{ $t("exp-csv") }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div
        v-if="mssg"
        align="center"
        class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
      >
        <p class="alert-close mb-0">
          {{ mssg }}
        </p>
      </div>
      <div
        v-else-if="Errormssg"
        align="center"
        class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
      >
        <p class="alert-close mb-0">
          {{ Errormssg }}
        </p>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <div class="table-responsive">
                <div
                  id="zero_config_wrapper"
                  class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
                >
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                      <div class="dataTables_length" id="zero_config_length">
                        <!-- <label
                          >{{ $t("show")
                          }}<select
                            v-model="sizeperpage"
                            name="entries"
                            class="form-control form-control-sm mx-1"
                            required
                          >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="40">40</option>
                            <option value="100">100</option> </select
                          >{{ $t("entries") }}</label
                        > -->
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <TableSearch @handleSearch="handleSearch" />
                    </div>
                  </div>
                  <div class="row" style="height: 22rem; overflow: auto;">
                    <div class="col-sm-12">
                      <table id="zero_config" class="table table-hover">
                        <thead class="data-table-bg">
                          <tr>
                            <th
                              :key="index"
                              v-for="(column, index) in tableColumns"
                              @click="sortBy(column[1])"
                              style="cursor: pointer; text-align: left"
                            >
                              {{ column[0] }}
                              <span
                                class="arrow"
                                :class="
                                  sortOrders[column[1]] > 0 ? 'asc' : 'dsc'
                                "
                              ></span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            :key="index"
                            v-for="(data, index) in paginatedData"
                            style="text-align: left;"
                            :class="{
                              'data-table-bg': index % 2 !== 0,
                            }"
                          >
                            <td>{{ data.date }}</td>
                            <td>{{ data.action }}</td>
                            <!-- <td>{{ data.status }}</td> -->
                          </tr>
                        </tbody>
                      </table>
                      <div v-if="this.logs.length == 0" align="center">
                        <h4 class="gray4">
                          No activities have been carried out
                        </h4>
                      </div>
                    </div>
                  </div>
                  <Pagination
                    :pageCount="pageCount"
                    :data="logs"
                    :sizeperpage="sizeperpage"
                    :pageNumber="pageNumber"
                    :pages="pages"
                    @goToLastPage="goToLastPage"
                    @nextPage="nextPage"
                    @handlePageChange="handlePageChange"
                    @goToFirstPage="goToFirstPage"
                    @prevPage="prevPage"
                    @onchange="onchange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer text-center">
      &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import store from "../../store/index";
import moment from "moment";
import tableMixin from "../../mixins/tableMixinWithBackend";
import Pagination from "../../components/PaginationNew.vue";
import TableSearch from "../../components/TableSearch.vue";

export default {
  name: "AuditTrail",
  mixins: [tableMixin],
  data() {
    return {
      csv: "",
      csvContent: "",
      encodedUri: "",
      searchQuery: "",
      dataTable: [],
      isLoading: true,
      fullPage: true,
      mssg: "",
      Errormssg: "",
      // tableColumns: [
      //   ["Date", "dateOrig"],
      //   ["Action", "action"],
      //   ["Status", "status"],
      // ],
    };
  },
  mounted() {
    this.handleGetLogs();
  },
  beforeRouteEnter(to, from, next) {
    // Checks if the user is a staff
    if (store.getters.profile.role === "staff") {
      next(from);
    } else {
      next();
    }
  },
  created() {
    let sortOrders = {};
    this.tableColumns.forEach(function(key) {
      sortOrders[key[1]] = 1;
    });
    this.sortOrders = sortOrders;
  },
  components: {
    Loading,
    Pagination,
    TableSearch,
  },
  computed: {
    ...mapGetters(["logs", "logspaginationMeta"]),
    tableColumns() {
      return [
        [this.$t("date"), "dateOrig"],
        [this.$t("action"), "action"],
        // [this.$t("stat"), "status"],
      ];
    },
    paginationMeta() {
      return this.logspaginationMeta;
    },
  },
  methods: {
    ...mapActions(["getLogs", "getSearchedLogs"]),
    exportRecord() {
      // Handle Empty Stats
      if (this.logs.length <= 0) {
        this.exportShow = false;
        return null;
      }
      var head = [
        [
          this.$t("day"),
          this.$t("date"),
          this.$t("time"),
          this.$t("action"),
          this.$t("stat"),
        ],
      ];
      var body = [];
      for (let i = 0; i < this.logs.length; i++) {
        let [day, date, time] = moment(this.logs[i].createdAt, "x", true)
          .format("ddd, MMM Do YYYY, hh:mm a")
          .split(", ");

        body.push([day, date, time, this.logs[i].action, this.logs[i].status]);
      }
      body.unshift(head);
      body = body.map((e) => e.join(",")).join("\n");
      let csvContent = "data:text/csv;charset=utf-8," + body;
      csvContent = encodeURI(csvContent);
      // // console.log(csvContent, "csv content");
      var link = document.createElement("a");
      link.setAttribute("href", csvContent);
      link.setAttribute("download", `logs.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    updateTable() {
      this.dataTable = [];
      for (let i = 0; i < this.logs.length; i++) {
        let date = moment
          .utc(this.logs[i].timestamp)
          .local()
          .format("ddd, MMM Do YYYY, hh:mm a");
        this.dataTable.push({
          user: this.logs[i].user,
          action: this.logs[i].description,
          status: this.logs[i].status,
          dateOrig: this.logs[i].createdAt,
          date,
        });
      }
    },
    handleCsv() {
      this.csv = [
        [
          this.$t("day"),
          this.$t("date"),
          this.$t("time"),
          this.$t("action"),
          this.$t("stat"),
        ],
      ];
      for (let i = 0; i < this.dataTable.length; i++) {
        let csvdata = [
          this.dataTable[i].date,
          this.dataTable[i].action,
          this.dataTable[i].status,
        ];
        this.csv.push(csvdata);
      }
      this.csv = this.csv.map((e) => e.join(",")).join("\n");
      this.csvContent = "data:text/csv;charset=utf-8," + this.csv;
      this.encodedUri = encodeURI(this.csvContent);
    },
    handleGetLogs() {
      this.isLoading = true;
      this.getLogs(this.params)
        .then(() => {
          this.updateTable();
        })
        .then(() => {
          this.handleCsv();
        })
        .then(() => {
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg = error.response.data.message;
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    doSearch() {
      let params = {
        ...this.params,
        name: this.searchQuery,
      };
      this.isLoading = true;
      this.getSearchedLogs(params)
        .then(() => {
          this.updateTable();
        })
        .then(() => {
          this.handleCsv();
        })
        .then(() => {
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg = error.response.data.message;
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
  },
  watch: {
    params() {
      this.handleGetLogs();
    },
  },
};
</script>

<style scoped>
/* td {
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
} */

th,
td {
  min-width: 150px;
}
th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 8px solid #000000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 8px solid #000000;
}
</style>

<i18n>
{
	"en": {
		"Search": "Search",
		"action": "Action",
		"batt": "Battery {name}",
		"date": "Date",
		"dev-name": "Device Name",
		"dev-tag": "Device Tag",
		"entries": "entries",
		"last-seen": "Last Seen",
		"next": "Next",
		"no-dev": "You have no devices yet",
		"no-read": "No readings yet",
		"no-search": "No search result found",
		"of": "of",
		"prev": "Previous",
		"readings": "readings",
		"show": "Show",
		"showing": "Showing",
		"stat": "Status",
		"temp": "Temperature {name}",
		"to": "to"
	},
	"es": {
		"Search": "Buscar",
		"action": "Acción",
		"batt": "Batería {name}",
		"date": "Fecha",
		"dev-name": "Nombre del dispositivo",
		"dev-tag": "Etiqueta de dispositivo",
		"entries": "entradas",
		"last-seen": "Ultima vez visto",
		"next": "Siguiente",
		"no-dev": "Aún no tienes dispositivos",
		"no-read": "Aún no hay lecturas",
		"no-search": "No se encontraron resultados de búsqueda",
		"of": "de",
		"prev": "Anterior",
		"readings": "Lecturas",
		"show": "Show",
		"showing": "Demostración",
		"stat": "Estado",
		"temp": "Temperatura {name}",
		"to": "a"
	},
	"fr": {
		"Search": "Chercher",
		"action": "action",
		"batt": "Batterie {name}",
		"date": "Date",
		"dev-name": "Nom de l'appareil",
		"dev-tag": "Balise d'appareil",
		"entries": "Les entrées",
		"last-seen": "Vue la dernière fois",
		"next": "Suivant",
		"no-dev": "Vous n'avez pas encore d'appareils",
		"no-read": "Pas encore de lectures",
		"no-search": "Aucun résultat de recherche trouvé",
		"of": "De",
		"prev": "précédent",
		"readings": "Lectures",
		"show": "Spectacle",
		"showing": "Montrant",
		"stat": "Statut",
		"temp": "Température {name}",
		"to": "à"
	},
	"sw": {
		"Search": "Tafuta",
		"action": "Hatua",
		"batt": "Betri {name}",
		"date": "Tarehe",
		"dev-name": "Jina la kifaa",
		"dev-tag": "Lebo ya Kifaa",
		"entries": "Viingilio",
		"last-seen": "Mara ya mwisho kuonekana",
		"next": "Ifuatayo",
		"no-dev": "Bado huna vifaa",
		"no-read": "Bado hakuna masomo",
		"no-search": "Hakuna matokeo ya utafutaji yaliyopatikana",
		"of": "ya",
		"prev": "Hapo awali",
		"readings": "usomaji",
		"show": "Onyesha",
		"showing": "Kuonesha",
		"stat": "Hali",
		"temp": "Halijoto {name}",
		"to": "Kwa"
	}
}
</i18n>
